import React, { lazy, useEffect, useRef, useState } from 'react'

const Modal = lazy(() => import('shared/components/modalProvider/modal'))

function ModalProvider() {
  const [isOpen, setIsOpen] = useState({ o: false })
  const modal = useRef()

  function onClose(val) {
    modal.current = null
    setIsOpen({ o: val })
  }

  useEffect(() => {
    function handleModal({ detail }) {
      modal.current = detail
      setIsOpen({ o: true })
    }
    window.addEventListener('modalEvent', handleModal)
    return () => window.removeEventListener('modalEvent', handleModal)
  }, [])

  if (isOpen.o) {
    return <Modal isOpen={isOpen.o} onClose={onClose} {...modal.current} />
  } else return null
}
export default ModalProvider
